import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	flags: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipLoading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	flags: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.flags',
		defaultMessage: '{count} {count, plural, one {flag} other {flags}}',
		description: 'Text that indicates how many feature flags there are.',
	},
	tooltipLoading: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-loading',
		defaultMessage: 'Loading...',
		description: 'Text displayed when tooltip content is loading.',
	},
});
export default messages;
